import { render, staticRenderFns } from "./EMelderComponentMeldungenMainTable.vue?vue&type=template&id=efb3ca7e&scoped=true"
import script from "./EMelderComponentMeldungenMainTable.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb3ca7e",
  null
  
)

export default component.exports